const mainProductCartButton = () => {
  const productFormSubmitElements = document.getElementsByClassName('product-form__submit');
  for (let i = 0; i < productFormSubmitElements.length; i++) {
    productFormSubmitElements[i].addEventListener('click', () => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event_name: 'addItermToCart',
        product_id: Shopify.product.id,
        product_name: Shopify.product.title,
      });
    });
  }
};
export default mainProductCartButton;
